import { Directive, TemplateRef, Input, SimpleChanges, OnChanges } from '@angular/core';

import { SgNavItemDefContext, MenuItemTemplates } from './interfaces';
import { SgNavMenuService } from './nav-menu.service';

@Directive({
  selector: '[sgNavItemDef]',
  standalone: false,
})
export class SgNavItemDefDirective implements OnChanges {
  @Input('sgNavItemDef') type: keyof MenuItemTemplates;

  constructor(
    public tRef: TemplateRef<SgNavItemDefContext>,
    private sgNavMenuService: SgNavMenuService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.type) {
      const { previousValue, currentValue } = changes.type;
      if (previousValue) {
        this.sgNavMenuService[previousValue] = undefined;
      }
      if (currentValue) {
        this.sgNavMenuService[currentValue] = this.tRef;
      }
    }
  }
}
